import Cookies from "js-cookie";
import { useEffect, useState } from "react";

export function useCookies(name: string) {
  //  @ts-ignore
  const [value, setValue] = useState<string>(Cookies.get(name) ?? null);

  useEffect(() => {
    performSetCookies();

    const intervalId = setInterval(() => {
      performSetCookies();
    }, 500);

    return () => {
      clearInterval(intervalId);
    };

    // eslint-disable-next-line
  }, []);

  function performSetCookies() {
    const cookiesValue = Cookies.get(name);

    //  @ts-ignore
    if (!cookiesValue) setValue(null);
    else setValue(cookiesValue);
  }

  return value;
}
